import React from 'react'

import { Field } from 'formik'

import { AdminContext } from 'contexts/AdminContext'

import { Form, Col } from '_zari/core'

const FechaEmisionFormGroup = ({ iError, iTouched, fIsSubmitting, handleChange, setFieldValue }) => {
  const __adminContext = React.useContext(AdminContext)

  const onChange = React.useCallback(
    e => {
      handleChange(e)

      const nuevaFecha = e.target.value
      setFieldValue('fechaVencimiento', nuevaFecha)
    },
    [handleChange, setFieldValue]
  )

  return (
    <Form.Group>
      <Form.Label text='FEC. EMISION' htmlFor='date-fechaEmision' md={6} alignRightAt='md' />
      <Col md={6}>
        <Field name='fechaEmision'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              id='date-fechaEmision'
              onChange={onChange}
              disabled={fIsSubmitting || !__adminContext.valoresConfiguracionUsuario.flagCambioFecha}
              isInvalid={iTouched && iError}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaEmisionFormGroup)
